import {Box, HBox} from '../../../../../components/core/view';
import {CustomText, H5Text, H6Text} from '../../../../../components/core/text';
import React, {useCallback} from 'react';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../../appStyles/hooks/theme';

import {DeliveryNotes} from '../../../../../../src/driver/types/orderDetails';
import If from '../../../../../../src/components/conditional/If';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface DeliveryNoteProps {
  deliveryNote: DeliveryNotes | undefined;
}

const DeliveryNote: React.FC<DeliveryNoteProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const deliveryNote = props?.deliveryNote;
  const building = deliveryNote?.building || '';
  const address = deliveryNote?.address || '';
  const parking = deliveryNote?.parking || '';
  const entrance = deliveryNote?.entrance || '';
  const access = deliveryNote?.access || '';
  const dropPoint = deliveryNote?.pikupPoint || '';
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};

  const renderComponent = useCallback(
    (title: string, value: string) => {
      return (
        <HBox style={styles.textBox}>
          <H6Text
            style={[
              styles.textAlignment,
              styles.flex1,
              {
                color: theme?.text?.blue?.[300],
                fontFamily: muli?.[700]?.normal,
              },
            ]}>
            {title}:{' '}
          </H6Text>
          <CustomText
            style={[
              styles.textAlignment,
              styles.flex2,
              {
                color: theme?.text?.gray?.[100],
                fontFamily: muli?.[600]?.normal,
              },
            ]}>
            {value}
          </CustomText>
        </HBox>
      );
    },
    [muli, theme?.text?.blue, theme?.text?.gray],
  );

  return (
    <Box style={styles.parentBox}>
      <H5Text
        style={[
          styles.apprtmentIns,
          {
            color: theme?.text.red[100],
          },
        ]}>
        {body?.deliveryNote?.apartmentInstruction}
      </H5Text>
      <If condition={building}>
        {renderComponent(body?.deliveryNote?.building, building)}
      </If>
      <If condition={address}>
        {renderComponent(body?.deliveryNote?.address, address)}
      </If>
      <If condition={parking}>
        {renderComponent(body?.deliveryNote?.parking, parking)}
      </If>
      <If condition={entrance}>
        {renderComponent(body?.deliveryNote?.entrance, entrance)}
      </If>
      <If condition={access}>
        {renderComponent(body?.deliveryNote?.access, access)}
      </If>
      <If condition={dropPoint}>
        {renderComponent(body?.deliveryNote?.dropPoint, dropPoint)}
      </If>
    </Box>
  );
};

export default React.memo(DeliveryNote);

const styles = StyleSheet.create({
  textAlignment: {
    textAlign: 'left',
  },
  parentBox: {
    paddingVertical: 10,
  },
  textBox: {
    marginBottom: 5,
    justifyContent: 'flex-start',
  },
  flex1: {
    flex: 0.25,
  },
  flex2: {
    flex: 0.75,
  },
  apprtmentIns: {
    textAlign: 'left',
    marginBottom: 10,
  },
});
